import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from 'app';

import './index.css';
// import reportWebVitals from "./reportWebVitals"

Sentry.init({
  dsn: 'https://df16f9974277d3f3cf8172396e1173ad@o4510433580744704.ingest.us.sentry.io/4510518379544576',
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'dark',
      autoInject: true,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// eslint-disable-next-line no-console
console.info(`Kapybro Dashboard [${__COMMIT_HASH__}]`);

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// reportWebVitals()
